import { reducer as form } from 'redux-form';
import locale from './languageReducer';
import auth from './authReducer';
import digitalCard from './digitalCardReducer';
import card from './cardReducer';
import user from './userReducer';
import providerLogin from './providerLoginReducer';
import myHealthSummaryReducer from './myHealthSummaryReducer';
import supportedLanguages from './supportedLanguagesReducer';

export default {
  form,
  locale,
  user,
  card,
  auth,
  digitalCard,
  providerLogin,
  myHealthSummaryReducer,
  supportedLanguages,
};
